import { assetManifest } from "../assets/manifest";

const materialIconNames = {
  close: "close",
  help: "help_outline",
  locked: "lock",
  mute: "volume_off",
  next: "chevron_right",
  pause: "stop",
  play: "play_arrow",
  previous: "chevron_left",
  reset: "restart_alt",
  settings: "settings",
  sound: "volume_up",
  success: "check",
  warning: "warning"
} as const;

const gameIconAssets = {
  autoLaunch: assetManifest.gameIconAutoLaunch,
  chargeBonus: assetManifest.gameIconChargeBonus,
  collectorAmp: assetManifest.gameIconCollectorAmp,
  coreValue: assetManifest.gameIconCoreValue,
  criticalDischarge: assetManifest.gameIconCriticalDischarge,
  extraShell: assetManifest.gameIconExtraShell,
  forge: assetManifest.gameIconForge,
  gateCount: assetManifest.gameIconGateCount,
  gateWidth: assetManifest.gameIconGateWidth,
  maxCores: assetManifest.gameIconMaxCores,
  offlineReactor: assetManifest.gameIconOfflineReactor,
  overchargedCore: assetManifest.gameIconOverchargedCore,
  overdrive: assetManifest.gameIconOverdrive,
  polaritySync: assetManifest.gameIconPolaritySync,
  profilePlayer: assetManifest.gameIconProfilePlayer,
  reactorStorm: assetManifest.gameIconReactorStorm,
  shellLens: assetManifest.gameIconShellLens,
  shellSpeed: assetManifest.gameIconShellSpeed,
  supplyCrates: assetManifest.gameIconSupplyCrates
} as const;

export type UiIconName = keyof typeof materialIconNames;
export type GameIconName = keyof typeof gameIconAssets;

export function createIcon(name: UiIconName, label: string): HTMLSpanElement {
  const icon = document.createElement("span");
  icon.className = "of-material-icon";
  icon.setAttribute("aria-label", label);
  icon.setAttribute("role", "img");
  icon.textContent = materialIconNames[name];
  return icon;
}

export function createGameIcon(name: GameIconName, label: string): HTMLImageElement {
  const icon = document.createElement("img");
  const asset = gameIconAssets[name];
  icon.className = "of-game-icon";
  icon.src = asset.url;
  icon.alt = label;
  icon.width = asset.width;
  icon.height = asset.height;
  icon.draggable = false;
  return icon;
}
